<template>
  <footer>
    <div class="tab-wrp">
      <div v-for="(item, index) in tabList" :key="index" @click="item.key === 'collect' ? invoiceCollection() : push(item.link)" :class="item.active ? 'tab tab-active' : 'tab'">
        <i class="basicmobilefont">{{item.icon}}</i>
        <p>{{item.title}}</p>
      </div>
    </div>
    <van-popup
      v-model="showCamera"
      position="bottom"
    >
      <p class="footer-photo-wrp">
        <span>拍照</span>
        <input @change="cameraChange" ref="camera" type="file" accept="image/*" />
      </p>
      <!-- <van-divider v-if="weixin" />
      <p class="footer-photo-wrp" v-if="weixin">
        <span @click="photoChange">相册</span>
      </p> -->
      <p class="divider"></p>
      <p v-tap="{methods: onCancel}" class="cancel">取消</p>
    </van-popup>
  </footer>
</template>

<script>
import { Popup, Divider } from 'vant'
import historyListenInit from '@utils/historyListener'
import { convertBase64UrlToBlob, system, cutImageBase64 } from '@utils/basicUtil'
export default {
  data: () => ({
    tabList: [
      {
        key: 'manager',
        active: false,
        title: '发票管理',
        icon: '\ue6b2',
        iconNotActive: '\ue6b2',
        iconActive: '\ue6b2',
        link: '/official-account/manager'
      },
      {
        key: 'collect',
        active: false,
        title: '发票采集',
        icon: '\ue6b1',
        iconNotActive: '\ue6b1',
        iconActive: '\ue6b1'
      },
      {
        key: 'open',
        active: false,
        title: '个人中心',
        icon: '\ue6b5',
        iconNotActive: '\ue6b5',
        iconActive: '\ue6b5',
        link: '/official-account/personal'
      }
    ],
    actions: [
      { name: '<input type="file" accept="image/*" capture="camera">拍照</input>' },
      { name: '相册' }
    ],
    showCamera: false,
    weixin: true
  }),
  computed: {
    photo: (vm) => {
      return vm.$refs.photo
    },
    camera: (vm) => {
      return vm.$refs.camera
    }
  },
  mounted () {
    historyListenInit()
    this.initTab()
    this.historyOnChange()
    this.isWeiXin()
  },
  methods: {
    isWeiXin () {
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') > -1) {
        this.weixin = true
      } else {
        this.weixin = false
      }
    },
    initTab () {
      const path = window.location.pathname
      this.tabList.forEach(item => {
        if (item.link === path) {
          item.active = true
          this.$emit('pathChange', item)
        } else {
          item.active = false
        }
      })
    },
    historyOnChange () {
      window.addHistoryListener('historychange', () => {
        this.initTab()
      })
    },
    push (link) {
      this.tabList.forEach(item => {
        if (item.active === true) {
          item.icon = item.iconNotActive
        } else {
          item.icon = item.iconActive
        }
      })
      this.$router.push(link)
    },
    invoiceCollection () {
      this.showCamera = true
    },
    onCancel () {
      this.showCamera = false
    },
    onSelect (item) {
      this.showCamera = false
    },
    cameraChange () {
      let file = this.camera.files[0]
      cutImageBase64(file, null, 1000, 0.8, (data) => {
        this.cutSuccess({ base64: data, file: convertBase64UrlToBlob(data) })
      })
    },
    photoChange () {
      let that = this
      window.wx.chooseImage({
        count: 1,
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album'], // 可以指定来源是相册还是相机，默认二者都有
        success: function (res) {
          let localId = res.localIds[0].toString()
          window.wx.getLocalImgData({
            localId: localId, // 图片的localID
            success: function (res) {
              let imgUrl = ''
              if (system() === 'ios') {
                imgUrl = res.localData
              } else {
                imgUrl = 'data:image/jpeg/png;base64,' + res.localData // localData是图片的base64数据，可以用img标签显示
              }

              let file = convertBase64UrlToBlob(imgUrl)

              that.cutSuccess({ base64: imgUrl, file })
            }
          })
        }
      })
    },
    cutSuccess (data) {
      this.$store.commit('officialAccount/changeImage', data)
      this.$router.push('/official-account/collect')
      this.onCancel()
    }
  },
  components: {
    [Popup.name]: Popup,
    [Divider.name]: Divider
  }
}
</script>

<style lang="less" scoped>
  footer {
    width: 100%;
    height: 116px;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1000;
    // overflow: hidden;
    box-shadow: 0px -1px 27px 0px rgba(51,51,51,0.1);
    .tab-wrp {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      height: 100%;
      .tab {
        height: 80px;
        width: fit-content;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
        color: rgba(112, 112, 112, 0.8);
        font-family: 'PingFang SC';
        font-weight:300;
        i {
          font-size: 30px;
        }
        p {
          font-size: 20px;
        }
      }
      .tab-active {
        color:rgba(33,150,243,0.8);
      }
    }
    .showCollect {
      z-index: 2500;
    }
    .van-popup--bottom.van-popup--round {
      border-radius: 0
    }
    .footer-photo-wrp {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 80px;
      font-size: 35px;
      position: relative;
      input {
        width: 100%;
        height: 100%;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .divider {
      height: 20px;
      width: 100%;
      overflow: hidden;
      background: #f7f8fa;
    }
    .cancel {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 80px;
      font-size: 35px;
      padding-bottom: 30px;
    }
    .van-divider {
      margin: 2px 0;
    }
  }
</style>
